import React from 'react';
import { useAppSelector } from 'src/store/hooks';

type Properties = {
    text: string;
    onClick: (ev?: any) => void;
    disabled?: boolean;
    btnClass?: string;
};

const SectionNavButton = (props: Properties) => {
    const config = useAppSelector(state => state.globalState.config);
    const shouldShowArrowLeft = React.useMemo(() => props.btnClass === 'button-previous', [props.btnClass]);
    const shouldShowArrowRight = React.useMemo(() => props.btnClass === 'button-next', [props.btnClass]);

    const arrowLeft = (
        <svg version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="58px" height="58px" viewBox="0 0 58 58" enableBackground="new 0 0 58 58" xmlSpace="preserve">
            <g id="Mask_Group_2" transform="matrix(0.035, 0.999, -0.999, 0.035, 131.94, -13.868)">
                <g id="arrow-point-to-right" transform="translate(12.838 111)">
                    <path id="Path_65" fill={config?.themeColor || 'inherit'} d="M23.89,9.163L-0.355-15.086c-1.651-1.432-1.828-3.932-0.396-5.584
			c1.432-1.651,3.932-1.829,5.583-0.396c0.141,0.122,0.276,0.255,0.398,0.396L26.682,0.787l21.453-21.455
			c1.646-1.438,4.146-1.269,5.586,0.377c1.303,1.49,1.303,3.716,0,5.207L29.474,9.165c-1.545,1.536-4.04,1.536-5.584,0L23.89,9.163z
			"/>
                </g>
            </g>
        </svg>

    );

    const arrowRight = (
        <svg version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="58px" height="58px" viewBox="0 0 58 58" enableBackground="new 0 0 58 58" xmlSpace="preserve">
            <g id="Mask_Group_2" transform="matrix(0.035, 0.999, -0.999, 0.035, 131.94, -13.868)">
                <g id="arrow-point-to-right" transform="translate(12.838 111)">
                    <path id="Path_65" fill={config?.themeColor || 'inherit'} d="M28.264-21.376L52.509,2.873c1.651,1.432,1.828,3.932,0.396,5.583
			c-1.432,1.651-3.932,1.829-5.583,0.396c-0.141-0.122-0.276-0.255-0.398-0.396L25.472-13L4.019,8.454
			c-1.646,1.438-4.146,1.27-5.586-0.376c-1.303-1.491-1.303-3.716,0-5.208L22.68-21.378c1.545-1.536,4.04-1.536,5.584,0
			L28.264-21.376z"/>
                </g>
            </g>
        </svg>
    );

    return (
        <button
            className={'menu-button ' + props.btnClass}
            style={{ color: config?.themeColor || '#acbcbc' }}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {shouldShowArrowLeft && arrowLeft}
            {props.text}
            {shouldShowArrowRight && arrowRight}
        </button>
    );
};

export default SectionNavButton;